// Sentry client bootstrap. Safe to import from client entry files.
// DSN is a public identifier — OK in client bundle.
import * as Sentry from "@sentry/react";

const DSN =
  (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env?.VITE_SENTRY_DSN ??
  "https://744d8fff91c6842666ee7b36b1597a01@o4511748131127296.ingest.us.sentry.io/4511748140892160";

let initialized = false;

export function initSentry() {
  if (initialized) return;
  if (typeof window === "undefined") return;
  if (!DSN) return;

  const host = window.location.hostname;
  const environment =
    host === "buddhaka.com" || host === "www.buddhaka.com"
      ? "production"
      : host.includes("preview") || host.endsWith(".lovable.app")
        ? "preview"
        : host === "localhost" || host === "127.0.0.1"
          ? "development"
          : "production";

  // Skip local development noise unless explicitly enabled.
  if (environment === "development" && !import.meta.env?.VITE_SENTRY_DEV) return;

  Sentry.init({
    dsn: DSN,
    environment,
    release: import.meta.env?.VITE_APP_RELEASE || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: environment === "production" ? 0.1 : 0.5,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      // Common browser/extension noise
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
      // Canvas quirk we already know about; tracked separately.
      "IndexSizeError",
    ],
    beforeSend(event) {
      // Drop events fired from Lovable's in-editor iframe preview to save quota.
      if (typeof window !== "undefined" && window.location.hostname.includes("lovableproject.com")) {
        return null;
      }
      return event;
    },
  });

  initialized = true;
}

export { Sentry };
